import { Dropdown, DropdownItem } from 'design-system-web';

export type Item<T> = DropdownItem<T>;

export default Dropdown;
